import clsx from "clsx";
import { FC, useState } from "react";
import { Row } from "react-table";
import Template, { templateLanguages } from "../../../../../models/Template";

type Props = {
  row: Row<Template>;
};

const CustomRow: FC<Props> = ({ row }) => {
  return (
    <>
      <tr
        {...row.getRowProps()}
        className="p-0 m-0"
        style={{
          paddingTop: "0px !important",
          paddingBottom: "0px !important",
        }}
      >
        {row.cells.map((cell) => {
          return (
            <td
              {...cell.getCellProps()}
              className={clsx({
                "p-0 m-0 text-end min-w-100px": cell.column.id === "actions",
              })}
              style={{
                paddingTop: "0px !important",
                paddingBottom: "0px !important",
              }}
            >
              {cell.render("Cell")}
            </td>
          );
        })}
      </tr>
    </>
  );
};

export { CustomRow };
